import BehaviorConfig from '@/models/app-config/behavior/behavior'
import DefaultForgotPassword from '@spa/components/pages/auth/signup/shared/form-parts/components/default/DefaultForgotPassword.vue'
import LedianForgotPassword from '@spa/components/pages/auth/signup/shared/form-parts/components/ledian/LedianForgotPassword.vue'
import Vue, { VueConstructor } from 'vue'
import SignupDefaultAttention from './components/default/DefaultAttention.vue'
import SignUpDefaultNote from './components/default/DefaultNote.vue'

export interface SignUpFormParts {
  readonly note: VueConstructor
  readonly forgotPassword: VueConstructor
  readonly attention: VueConstructor
}
type SignUpFormPartsGenerator = (behavior: BehaviorConfig) => SignUpFormParts

type DefaultFormPartsGenerator = (diff?: Partial<SignUpFormParts>) => SignUpFormPartsGenerator
export const defaultFormParts: DefaultFormPartsGenerator = (diff = {}) => behavior => ({
  note: SignUpDefaultNote,
  forgotPassword: DefaultForgotPassword,
  attention: defaultAttentionWith(behavior.groupLabel),
  ...diff,
})
const defaultAttentionWith = (hostName: string) => Vue.extend({
  components: { SignupDefaultAttention },
  template: `<signup-default-attention host-name="${hostName}" />`,
})

export const mycolorFormParts = defaultFormParts()

export const vilbFormParts = defaultFormParts({
  attention: defaultAttentionWith('美ラボ'),
})

export const fitowaFormParts = defaultFormParts({
  attention: defaultAttentionWith('FITOWA'),
})

export const ledianFormParts = defaultFormParts({
  forgotPassword: LedianForgotPassword,
})

export const loadingFormParts: SignUpFormParts = {
  note: Vue.extend({ template: '<div></div>' }),
  forgotPassword: Vue.extend({ template: '<div></div>' }),
  attention: Vue.extend({ template: '<div></div>' }),
}
